import axios from './../../config/axios';

function index(params) {
    params.limit = params.itemsPerPage;
    params.offset = (params.page - 1) * params.limit;

    return axios().get(`/purchase/cost-components`, { params })
}

function find(id) {
    return axios().get(`/purchase/cost-components/${id}`)
}

function store(data) {
    return axios().post(`/purchase/cost-components`, data);
}

function search(query) {
    return axios().get(`/purchase/cost-component-search`, { params: { search: query } })
}

function remove(id) {
    return axios().delete(`/purchase/cost-components/${id}`)
}

function update(id, data) {
    return axios().put(`/purchase/cost-components/${id}`, data);
}

export default {
    search,
    store,
    remove,
    find,
    update,
    index
}